/**
 * editor API does not care
 * about appData and token seems it is historical artifact
 */
const emptyAppData = {};
const token = '';
/**
 * TODO: it feels like this class is redundant
 * we need to find a good way to get rid of it
 */
export class HostAPIBase {
    constructor(platformApiMethods) {
        this.platformApiMethods = platformApiMethods;
        this.editor = {
            openLanguageSupportPanel: (appDefinitionId) => {
                this.platformApiMethods.editor.openPanel({ appDefinitionId }, 'panels.toolPanels.languageSupport', {}, true);
            },
            openFontsUploadPanel: (appDefinitionId) => {
                this.platformApiMethods.editor.openPanel({ appDefinitionId }, 'panels.toolPanels.fontsUploadPanel', {}, true);
            },
            openDashboardPanel: (appDefinitionId, options) => {
                this.platformApiMethods.editor.openDashboardPanel({ appDefinitionId }, token, options);
            },
            openPanel: (panelId, props) => {
                this.platformApiMethods.editor.openPanel(emptyAppData, panelId, props);
            },
            userPreferences: {
                set: (appDefinitionId, preferences) => {
                    return this.platformApiMethods.editor.userPreferences.site.set({ appDefinitionId }, token, preferences);
                },
                get: (appDefinitionId, keys) => {
                    return this.platformApiMethods.editor.userPreferences.site.get({ appDefinitionId }, token, keys);
                },
            },
            openLinkPanel: (options) => {
                return this.platformApiMethods.editor.openLinkPanel(emptyAppData, token, options);
            },
            selectMedia: async (options) => this.platformApiMethods.editor.selectMedia?.(options),
            selectLink: (value, options) => {
                return this.platformApiMethods.editor.selectLink?.(value, options);
            },
            openMediaPanel: (options) => {
                return this.platformApiMethods.editor.openMediaPanel(emptyAppData, token, options);
            },
            openFontPicker: async (options, onStyleChange, onFontChangedV2) => {
                await this.platformApiMethods.editor.openFontPicker(emptyAppData, token, options, onStyleChange, onFontChangedV2);
            },
            openColorPicker: async (options, onColorChange) => {
                await this.platformApiMethods.editor.openColorPicker(emptyAppData, token, options, onColorChange);
            },
            selectFontFamily: (options) => this.platformApiMethods.editor.selectFontFamily?.(options),
            selectColor: (options) => this.platformApiMethods.editor.selectColor?.(options),
            selectFontWeight: (options) => this.platformApiMethods.editor.selectFontWeight?.(options),
            selectTextTheme: (options) => this.platformApiMethods.editor.selectTextTheme?.(options),
            registerToolsPanel: async (appData, toolsMenuItemConfig, toolsPanelConfig) => {
                return this.platformApiMethods.editor.registerToolsPanelWithOpener(appData, toolsMenuItemConfig, toolsPanelConfig);
            },
            generateComponentLayout: (options) => {
                return this.platformApiMethods.editor.generateComponentLayout?.(options);
            },
            selection: {
                getSelectedComponents: () => {
                    return this.platformApiMethods.editor.selection.getSelectedComponents();
                },
                getSingleSelectedOrThrow: () => this.platformApiMethods.editor.selection.getSingleSelectedOrThrow(),
            },
            info: {
                getEditorSessionId: () => {
                    return this.platformApiMethods.editor.info.getEditorSessionId();
                },
            },
            templates: {
                hasTemplates: (editorPointer) => {
                    return (this.platformApiMethods.editor.hasTemplates?.(editorPointer) || false);
                },
            },
        };
        this.viewState = {
            getViewState: (componentRef) => {
                return this.platformApiMethods.editor.widgets.getViewState(emptyAppData, componentRef);
            },
            setViewState: (componentRef, stateName) => {
                this.platformApiMethods.editor.widgets.setViewState(emptyAppData, componentRef, stateName);
            },
        };
    }
}
//# sourceMappingURL=HostAPIBase.js.map